'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wrapClass = require('../utils/wrapClass');

var _wrapClass2 = _interopRequireDefault(_wrapClass);

var _constants = require('../utils/constants');

var _MapPropTypes = require('../utils/MapPropTypes');

var _typeTransform = require('../utils/typeTransform');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * GroundOverlay
 * @author terencewu
 */


var controlledPropTypes = {
  bounds: _propTypes2.default.shape(_MapPropTypes.Bounds),
  opacity: _propTypes2.default.number,
  imageUrl: _propTypes2.default.string,
  displayOnMinLevel: _propTypes2.default.number,
  dispalyOnMaxLevel: _propTypes2.default.number
};
var controlledPropUpdater = {
  bounds: function bounds(obj, arg) {
    obj.setBounds((0, _typeTransform.toBMapBounds)(arg));
  },
  opacity: function opacity(obj, arg) {
    obj.setOpacity(arg);
  },
  imageUrl: function imageUrl(obj, arg) {
    obj.setImageURL(arg);
  },
  displayOnMinLevel: function displayOnMinLevel(obj, arg) {
    obj.setDisplayOnMinLevel(arg);
  },
  dispalyOnMaxLevel: function dispalyOnMaxLevel(obj, arg) {
    obj.setDispalyOnMaxLevel(arg);
  }
};
var publicMethodMap = ['getBounds', 'getOpacity', 'getImageURL', 'getDisplayOnMinLevel', 'getDispalyOnMaxLevel', 'show', 'hide'];
var eventMap = ['click', 'dblclick'];
var Ground = (_temp = _class = function (_React$Component) {
  _inherits(Ground, _React$Component);

  function Ground(props) {
    _classCallCheck(this, Ground);

    return _possibleConstructorReturn(this, (Ground.__proto__ || Object.getPrototypeOf(Ground)).call(this, props));
  }

  _createClass(Ground, [{
    key: 'getInstanceFromComponent',
    value: function getInstanceFromComponent(component) {
      return component.ground;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var bounds = this.props.bounds; // eslint-disable-line react/prop-types

      this.ground = new BMap.GroundOverlay((0, _typeTransform.toBMapBounds)(bounds)); // eslint-disable-line no-undef

      this.props[_constants.MAP].addOverlay(this.ground);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      if (children) {
        return _react2.default.createElement('div', null, children);
      }

      return false;
    }
  }]);

  return Ground;
}(_react2.default.Component), _class.propTypes = _defineProperty({}, _constants.MAP, _propTypes2.default.object), _temp);
exports.default = (0, _wrapClass2.default)(Ground, controlledPropTypes, controlledPropUpdater, publicMethodMap, eventMap);
module.exports = exports['default'];